export const BRAND = {
    name: 'Waylthlane Financials',
    tagline: 'Investment Reimagined',
    address: 'Rajnagar Extension, Ghaziabad, Uttar Pradesh, India',
    phones: ['+91 9341787996', '+91 8130963466'],
    email: 'bhartendu.kumar@gmail.com',
    whatsapp: '919341787996', // E.164 without '+'
    logoUrl:
        'https://customer-assets.emergentagent.com/job_2fc41207-397a-4318-b640-7b91d0fc65a5/artifacts/4ffz19jm_WhatsApp%20Image%202026-06-15%20at%208.14.59%20PM.jpeg',
};

// Smart WhatsApp link:
// - On mobile -> uses wa.me (opens native app)
// - On desktop -> goes directly to web.whatsapp.com (bypasses api.whatsapp.com which some corporate networks/firewalls block)
export function whatsappUrl(message = 'Hi Waylthlane, I would like to book a consultation.') {
    const text = encodeURIComponent(message);
    const isMobile =
        typeof navigator !== 'undefined' &&
        /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
    return isMobile
        ? `https://wa.me/${BRAND.whatsapp}?text=${text}`
        : `https://web.whatsapp.com/send?phone=${BRAND.whatsapp}&text=${text}`;
}

export const STATS = [
    { id: 'experience', value: '62+', label: 'Years of Combined Experience' },
    { id: 'clients', value: '500+', label: 'Happy Clients Served' },
    { id: 'advisors', value: '3', label: 'Founding Advisors' },
    { id: 'trust', value: '100%', label: 'Client-First Philosophy' },
];

export const FOUNDERS = [
    {
        id: 'deepti',
        name: 'Deepti B Kumar',
        role: 'Co-Founder',
        years: '23+',
        photo:
            'https://customer-assets.emergentagent.com/job_2fc41207-397a-4318-b640-7b91d0fc65a5/artifacts/z1n6kwhh_WhatsApp%20Image%202026-06-15%20at%208.15.46%20PM%20%281%29.jpeg',
        qualifications: [
            'MBA, Human Resources',
            'Bachelor of Economics, University of Delhi',
        ],
        expertise: [
            'Client Relationships',
            'Family Financial Planning',
            'Organisational Leadership',
        ],
        bio:
            'Deepti brings a rare blend of organisational insight and deep client empathy. With over two decades of professional experience, she leads the firm’s client relationships and long-term financial planning practice — helping families make calm, informed decisions across every life stage.',
    },
    {
        id: 'bhartendu',
        name: 'Bhartendu Kumar',
        role: 'Co-Founder',
        years: '21+',
        photo:
            'https://customer-assets.emergentagent.com/job_2fc41207-397a-4318-b640-7b91d0fc65a5/artifacts/bv49rhgq_WhatsApp%20Image%202026-06-15%20at%208.15.46%20PM.jpeg',
        qualifications: [
            'MBA, Marketing & Sales',
            'Executive Management & Development Programme, IIM Kozhikode',
        ],
        expertise: [
            'Strategic Financial Advisory',
            'Wealth Creation Strategy',
            'Business & Relationship Development',
        ],
        bio:
            'Bhartendu is a strategic financial advisor known for clarity, conviction and a long-horizon view. He guides professionals and business owners through portfolio construction, risk calibration and goal-based planning — building wealth that compounds quietly across decades.',
    },
    {
        id: 'shib',
        name: 'Shib Shankar Sahoo',
        role: 'Co-Founder',
        years: '18+',
        photo:
            'https://customer-assets.emergentagent.com/job_2fc41207-397a-4318-b640-7b91d0fc65a5/artifacts/xxnhtti1_WhatsApp%20Image%202026-06-15%20at%208.27.47%20PM.jpeg',
        qualifications: ['MBA, Marketing & Sales'],
        expertise: [
            'Client Engagement',
            'Financial Planning Support',
            'Long-term Advisory Relationships',
        ],
        bio:
            'Shib partners with individuals and families on the financial decisions that matter most — from foundational planning to retirement readiness. His steady, detail-oriented approach has earned him long-standing client relationships built on reliability and trust.',
    },
];

export const SERVICES = [
    { id: 'financial-planning', icon: 'compass', title: 'Financial Planning', desc: 'A clear, written plan that aligns every rupee with the life you want to build.' },
    { id: 'wealth-management', icon: 'gem', title: 'Wealth Management', desc: 'Holistic management of assets, liabilities and goals — calibrated to your risk.' },
    { id: 'retirement', icon: 'sunset', title: 'Retirement Planning', desc: 'Build a retirement income strategy designed to outlast market cycles.' },
    { id: 'tax', icon: 'receipt', title: 'Tax Planning Guidance', desc: 'Coordinate investments and income for thoughtful, compliant tax outcomes.' },
    { id: 'investment-advisory', icon: 'line-chart', title: 'Investment Advisory', desc: 'Independent, research-led guidance across asset classes and time horizons.' },
    { id: 'insurance', icon: 'shield', title: 'Insurance Planning', desc: 'Protect what you have built with the right blend of life and health cover.' },
    { id: 'education', icon: 'graduation-cap', title: "Children's Education", desc: 'Plan systematically for school, college and global education milestones.' },
    { id: 'goal-based', icon: 'target', title: 'Goal-Based Planning', desc: 'Tie each portfolio to a real outcome — a home, a sabbatical, a legacy.' },
];

export const INVESTMENTS = [
    { id: 'equity', title: 'Equity Investments', desc: 'Long-term wealth creation through carefully selected equity opportunities.' },
    { id: 'mutual-funds', title: 'Mutual Funds', desc: 'Diversified options aligned with your risk profile and financial goals.' },
    { id: 'pms', title: 'Portfolio Management Services (PMS)', desc: 'Professionally managed portfolios for eligible investors.' },
    { id: 'aif', title: 'Alternative Investment Funds (AIF)', desc: 'Specialised opportunities designed for sophisticated investors.' },
    { id: 'sif', title: 'Specialized Investment Funds (SIF)', desc: 'Customised investment approaches for specific financial objectives.' },
    { id: 'bonds', title: 'Bonds & Fixed Income', desc: 'Stability, income generation and capital preservation focused solutions.' },
    { id: 'commodities', title: 'Commodities', desc: 'Exposure to commodity markets as part of a diversified strategy.' },
    { id: 'unlisted', title: 'Unlisted & Pre-IPO Shares', desc: 'Select private and pre-listing opportunities, subject to eligibility.' },
];

export const WHY_US = [
    { title: 'Personalised Advice', desc: 'Every plan is custom built — no off-the-shelf portfolios.' },
    { title: 'Transparent Process', desc: 'You see the rationale, the costs, and the trade-offs at every step.' },
    { title: 'Long-Term Focus', desc: 'We optimise for decades of compounding, not quarters.' },
    { title: 'Client-Centric Approach', desc: 'Your goals lead the strategy — products serve the goals.' },
    { title: 'Experienced Advisors', desc: '62+ years of combined practitioner experience.' },
    { title: 'Proven Track Record', desc: '500+ households and professionals served.' },
];

export const PROCESS = [
    { step: '01', title: 'Discovery Call', desc: 'A focused conversation to understand your goals, life stage and concerns.' },
    { step: '02', title: 'Financial Assessment', desc: 'A complete picture: income, expenses, assets, liabilities, risk and gaps.' },
    { step: '03', title: 'Customised Strategy', desc: 'A written, goal-linked plan with clear allocations and milestones.' },
    { step: '04', title: 'Ongoing Wealth Growth', desc: 'Regular reviews, rebalancing and course corrections as life evolves.' },
];

export const FAQS = [
    { id: 'start', q: 'How do I start financial planning?', a: 'Begin with a complimentary discovery call. We listen to your goals, gather a high-level financial snapshot and outline a clear next step. There is no pressure to commit on the first meeting.' },
    { id: 'options', q: 'What investment options do you advise on?', a: 'We provide advisory and facilitation across mutual funds, equity, PMS, AIF, SIF, bonds, commodities and select unlisted opportunities — chosen to fit your risk profile, time horizon and goals.' },
    { id: 'review', q: 'How often will my portfolio be reviewed?', a: 'Standard engagements include scheduled quarterly reviews, with additional check-ins on material life events or market dislocations. You can always reach your advisor in between.' },
    { id: 'retirement', q: 'Do you provide retirement planning?', a: 'Yes. Retirement planning is one of our core practice areas — covering corpus building, withdrawal strategy, healthcare provisioning and legacy planning.' },
    { id: 'process', q: 'What is your advisory process?', a: 'Discovery → Financial assessment → Customised written strategy → Implementation → Ongoing reviews and adjustments. Every step is documented and discussed with you.' },
];
